import React from "react";

const BookBoldNeueIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 4.75L2.75 2.75V15.25L10 17.25",
  stroke: "currentColor",
  strokeWidth: "1.5",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 5V17",
  stroke: "currentColor",
  strokeWidth: "1.5",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 4.75L17.25 2.75V15.25L10 17.25",
  stroke: "currentColor",
  strokeWidth: "1.5",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(BookBoldNeueIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;